import {createAction} from 'redux-actions';

const PREFIX = 'search::';

export const ActionTypes = {
  SET_SEARCH_INPUT_VALUE : `${PREFIX}SET_SEARCH_INPUT_VALUE`
};

export const setSearchInputValue = createAction('SET_SEARCH_INPUT_VALUE');
